import { useContext, useEffect } from 'react';

import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';
// components
import Page from '../components/Page';
import { UserContext } from '../context/userContext';
import { ROLE } from '../Services/auth.service';

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function Page404() {
  const { t, i18n } = useTranslation();
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {}, [i18n.language]);

  const handleBackClick = () => {
    switch (user.role) {
      case ROLE.Admin:
        navigate('/booking', { replace: true });
        break;
      case ROLE.Root:
        navigate('/booking', { replace: true });
        break;
      case ROLE.CSKH:
        navigate('/customer', { replace: true });
        break;
      case ROLE.Employee:
        navigate('/promotion', { replace: true });
        break;
      case ROLE.Manager:
        navigate('/booking', { replace: true });
        break;
      case ROLE.Recruit:
        navigate('/recruit', { replace: true });
        break;

      default:
        break;
    }
  };

  return (
    <Page title="404 Page Not Found">
      <Container>
        <ContentStyle sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Box component={'img'} src={'static/logo.png'} sx={{ width: '300px', mb: 2 }} />

          <Typography variant="h3" paragraph>
            {t('page404.title')}
          </Typography>

          <Typography sx={{ color: 'text.secondary' }}>{t('page404.subTitle')} </Typography>

          <Box
            component="img"
            src="/static/illustrations/illustration_404.svg"
            sx={{ height: 260, mx: 'auto', my: { xs: 5, sm: 10 } }}
          />

          <Button onClick={handleBackClick} size="large" variant="contained">
            {t('page404.back')}
          </Button>
        </ContentStyle>
      </Container>
    </Page>
  );
}
